module.exports = __webpack_public_path__ + "static/media/django.4829eb61.png";